module.exports = __webpack_public_path__ + "static/vo-86f53838487f821a9c867a62b5aefa0d.mp3";